import { AppState } from "../../../redux-configuration/AppState";
import { Company } from "../../domain/entity/company";

export const loadCompanyDetailsLoadingSelector = (appState: AppState): boolean => appState.company.loadCompanyDetails.loading
export const loadCompanyDetailsErrorSelector = (appState: AppState): string | undefined => appState.company.loadCompanyDetails.error
export const companyDetailsSelector = (appState: AppState): Company | null => appState.company.loadCompanyDetails.company
